import React from "react";

export default function ExploreItemModal({
  onClose,
  isVideo,
  url,
  title,
  isDownloadable = false,
  downloadUrl = "",
}) {
  return (
    <div
      className="modal show"
      style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.9)",
      }}
      tabIndex="-1"
      aria-labelledby="exploreItemLabel"
      aria-hidden="true"
      data-bs-backdrop="true"
      data-bs-keyboard="true"
    >
      <div
        className="modal-dialog modal-xl"
        style={{
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className="modal-content"
          style={{
            flexGrow: 1,
            backgroundColor: "#ffffff",
            borderRadius: "15px",
            padding: "0 20px",
          }}
        >
          <div
            className="modal-body"
            style={{
              overflowY: "auto",
              maxHeight: "90vh",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className="d-flex align-items-center gap-3">
                {/* Download Button */}
                <h5 style={{ margin: 0 }}>{title}</h5>
                {isDownloadable && (
                  <button
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = downloadUrl || url;
                      link.target = "_blank";
                      link.rel = "noopener noreferrer";

                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                    style={{
                      border: "none",
                      background: "#ffffff",
                      color: "#fff",
                      padding: "6px",
                      borderRadius: "6px",
                      fontSize: "0.75rem",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <i
                      className={"fa-solid fa-download"}
                      style={{
                        fontSize: "1rem",
                        color: "black",
                      }}
                    />
                  </button>
                )}
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
                style={{
                  position: "absolute",
                  top: "15px",
                  right: "15px",
                  zIndex: 10501,
                }}
              ></button>
            </div>
            <iframe
              src={url}
              title={title}
              allow={
                isVideo
                  ? "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  : undefined
              }
              allowFullScreen={isVideo}
              style={{
                width: "100%",
                height: "80vh",
                border: "none",
                marginTop: "10px",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
